export const BRIDGE_CONTRACT_REGISTRY = {
  1: {
    bridge: '0x0741C26aF64b15C4d6F59acf4F9A1D7dC89Cc438',
    erc20Handler: '0xc74478e6B3285312bfDeF91Aea14D07a7aec8855'
  },

  11155111: {
    bridge: '0xA28697Cb36C7bFEbCd495822404CA5092F25e0de',
    erc20Handler: '0x0D80076dE8c8C5C11e75Dc29718bF9d32d824D7a'
  },

  71117: {
    bridge: '0x1469a7842BFD9ED786Dbb5044c4Dc5025a241827',
    erc20Handler: '0xE26b2BF14664FD9C932CaDC3cA8C779d5BbFF913'
  },

  171717: {
    bridge: '0x534afD1209540e60838E8D2Ac761a1B0f43aB663',
    erc20Handler: '0x4E6FD9223D0cd7996Fd50876Da2e83C5316C179e'
  },

  97: {
    bridge: '0xD732B4DFEb181458C7a39952C22E71bb1E945ca9',
    erc20Handler: '0x9373D5cec0833Ae2f8b45b22A3159a7B956d7B69'
  },

  56: {
    bridge: '0xc74478e6B3285312bfDeF91Aea14D07a7aec8855',
    erc20Handler: '0xBCeD2AF67a3BE7cEd7870FFC386A9759E7481D50'
  }
}